'use client'
import { useTranslations } from 'next-intl'
import { BaseEmptyStateProps } from '../types'
import { BaseEmptyState } from '../BaseEmptyState'

export const EmptyCard: React.FC<BaseEmptyStateProps> = (props) => {
  const t = useTranslations('emptyStates.card')

  return (
    <BaseEmptyState
      {...props}
      title={t('title')}
      description={t('description')}
      imageSrc="/emptyStates/product-illustration.svg"
      variant="subtle"
    />
  )
}
